import { useRef, useState } from "react";
import emailjs from "emailjs-com";

export default function Contact() {
  const [complaintOpen, setComplaintOpen] = useState(false);
  const [sendingMain, setSendingMain] = useState(false);
  const [sendingComplaint, setSendingComplaint] = useState(false);

  const mainFormRef = useRef(null);
  const complaintFormRef = useRef(null);

  const SERVICE_ID = "service_cljztoq";
  const MAIN_TEMPLATE_ID = "template_aw80edc"; // "Գրեք մեզ" template
  const COMPLAINT_TEMPLATE_ID = "template_auemxvb"; // "Բողոք" template
  const PUBLIC_KEY = "DgPK5jQk58ECGFxnQ";

  const sendMain = async (e) => {
    e.preventDefault();
    if (!mainFormRef.current) return;

    try {
      setSendingMain(true);
      await emailjs.sendForm(
          SERVICE_ID,
          MAIN_TEMPLATE_ID,
          mainFormRef.current,
          PUBLIC_KEY
      );
      alert("Հաղորդագրությունը ուղարկված է ✅");
      mainFormRef.current.reset();
    } catch (err) {
      alert("Սխալ տեղի ունեցավ ❌");
    } finally {
      setSendingMain(false);
    }
  };

  const sendComplaint = async (e) => {
    e.preventDefault();
    if (!complaintFormRef.current) return;

    try {
      setSendingComplaint(true);
      await emailjs.sendForm(
          SERVICE_ID,
          COMPLAINT_TEMPLATE_ID,
          complaintFormRef.current,
          PUBLIC_KEY
      );
      alert("Բողոքը ուղարկված է ✅");
      complaintFormRef.current.reset();
      setComplaintOpen(false);
    } catch (err) {
      alert("Սխալ տեղի ունեցավ ❌");
    } finally {
      setSendingComplaint(false);
    }
  };

  return (
      <section id="contact" className="py-16 md:py-24 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 md:mb-16 text-center">
            Կապ մեզ հետ
          </h2>

          <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row mb-12">
            <div className="bg-blue-900 text-white p-8 md:p-12 md:w-2/5 flex flex-col justify-between">
              <div>
                <h3 className="text-2xl font-bold mb-8">Կոնտակտային տվյալներ</h3>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="mr-2 flex-shrink-0 mt-1"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <div>
                      <p className="font-semibold">Հեռախոսահամարներ</p>
                      <a
                          href="tel:+37455828343"
                          className="mt-1 text-blue-200 hover:text-white transition"
                      >
                        +374 55 828343
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="mr-2 flex-shrink-0 mt-1"
                    >
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                    <div>
                      <p className="font-semibold">Էլ. հասցե</p>
                      <a
                          href="mailto:info@testinvest.am"
                          className="mt-1 text-blue-200 hover:text-white transition underline"
                      >
                        info@testinvest.am
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="mr-2 flex-shrink-0 mt-1"
                    >
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                    </svg>
                    <div>
                      <p className="font-semibold">Facebook</p>
                      <a
                          href="https://www.facebook.com/testinvest.certificate"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mt-1 text-blue-200 hover:text-white transition-colors"
                      >
                        testinvest.certificate
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="mr-2 flex-shrink-0 mt-1"
                    >
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <div>
                      <p className="font-semibold">Հասցե</p>
                      <p className="mt-1 text-blue-200">ՀՀ, ք. Երևան, Կոմիտաս 49/2</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-8 md:p-12 md:w-3/5">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">Գրեք մեզ</h3>

              {/* MAIN FORM */}
              <form ref={mainFormRef} onSubmit={sendMain} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Անուն</label>
                    <input
                        name="name"
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                        placeholder="Ձեր անունը"
                        required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Հեռախոս</label>
                    <input
                        name="phone"
                        type="tel"
                        className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                        placeholder="+374..."
                        required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Էլ Հասցե</label>
                  <input
                      name="complaint_email"
                      type="email"
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                      placeholder="Էլ Հասցե"
                      required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Հաղորդագրություն</label>
                  <textarea
                      name="message"
                      rows={4}
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                      placeholder="Ինչպե՞ս կարող ենք օգնել..."
                      required
                  />
                </div>

                <button
                    type="submit"
                    disabled={sendingMain}
                    className="w-full bg-blue-900 text-white font-bold py-4 rounded-lg hover:bg-blue-800 transition-colors shadow-lg disabled:opacity-60"
                >
                  {sendingMain ? "Ուղարկվում է..." : "Ուղարկել"}
                </button>

                <button
                    type="button"
                    onClick={() => setComplaintOpen(true)}
                    className="w-full mt-4 border border-blue-900 text-blue-900 font-semibold py-3 rounded-lg hover:bg-blue-50 transition"
                >
                  Բողոքներ և գանգատներ
                </button>
              </form>
            </div>
          </div>

          {/* Google Map */}
          <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden h-96">
            <iframe
                width="100%"
                height="100%"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3047.0502133195423!2d44.51374247624544!3d40.20794596831978!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abd35f32ca93d%3A0x1e6589cc4864f1f2!2s49%2F2%20Komitas%20Ave%2C%20Yerevan%200014!5e0!3m2!1sru!2sam!4v1769545526126!5m2!1sru!2sam"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Google Map"
            ></iframe>
          </div>
        </div>

        {/* COMPLAINT MODAL */}
        {complaintOpen && (
            <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
              <div className="bg-white w-full max-w-xl rounded-2xl shadow-xl p-6 relative">
                <button
                    onClick={() => setComplaintOpen(false)}
                    className="absolute right-4 top-4 text-gray-400 hover:text-black"
                >
                  ✕
                </button>

                <h3 className="text-2xl font-bold mb-6 text-center">Բողոքներ և գանգատներ</h3>

                <form ref={complaintFormRef} onSubmit={sendComplaint} className="space-y-4">
                  <input
                      name="full_name"
                      className="w-full border rounded-lg p-3"
                      placeholder="Անուն Ազգանուն"
                      required
                  />

                  <input
                      name="complaint_phone"
                      className="w-full border rounded-lg p-3"
                      placeholder="Հեռախոս"
                      required
                  />

                  <input
                      name="complaint_email"
                      type="email"
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                      placeholder="Էլ Հասցե"
                      required
                  />

                  <textarea
                      name="complaint_message"
                      rows={4}
                      className="w-full border rounded-lg p-3"
                      placeholder="Նկարագրեք խնդիրը"
                      required
                  />

                  <button
                      type="submit"
                      disabled={sendingComplaint}
                      className="w-full bg-blue-900 text-white py-3 rounded-lg hover:bg-blue-800 disabled:opacity-60"
                  >
                    {sendingComplaint ? "Ուղարկվում է..." : "Ուղարկել բողոքը"}
                  </button>
                </form>
              </div>
            </div>
        )}
      </section>
  );
}